/**
 * Parse value
 * @param value
 * @return {any}
 */
export function parse (value) {
    return JSON.parse(value);
}

/**
 * Stringify value
 * @param value
 * @return {string}
 */
export function stringify (value) {
    return JSON.stringify(value);
}

/**
 * Clone value
 * @param value
 * @return {*}
 */
export function clone (value) {
    return parse(stringify(value));
}